var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.90625C3.5 5.04297 3.58203 5.125 3.71875 5.125H9.40625C9.51562 5.125 9.625 5.04297 9.625 4.90625V4.03125C9.625 3.92188 9.51562 3.8125 9.40625 3.8125H3.71875C3.58203 3.8125 3.5 3.92188 3.5 4.03125V4.90625ZM3.71875 7.3125H9.40625C9.51562 7.3125 9.625 7.23047 9.625 7.09375V6.21875C9.625 6.10938 9.51562 6 9.40625 6H3.71875C3.58203 6 3.5 6.10938 3.5 6.21875V7.09375C3.5 7.23047 3.58203 7.3125 3.71875 7.3125ZM11.8945 11.6875C12.0859 11.6602 12.25 11.4688 12.25 11.25V1.1875C12.25 0.96875 12.0312 0.75 11.8125 0.75H2.1875C0.957031 0.75 0 1.73438 0 2.9375V12.5625C0 13.793 0.957031 14.75 2.1875 14.75H11.8125C12.0312 14.75 12.25 14.5586 12.25 14.3125V13.875C12.25 13.6836 12.0859 13.4922 11.8945 13.4648C11.7578 13.1094 11.7578 12.043 11.8945 11.6875ZM10.7734 11.6875C10.6914 12.1797 10.6914 12.9727 10.7734 13.4375H2.1875C1.69531 13.4375 1.3125 13.0547 1.3125 12.5625C1.3125 12.0977 1.69531 11.6875 2.1875 11.6875H10.7734ZM10.9375 2.0625V10.375H2.1875C1.85938 10.375 1.55859 10.457 1.3125 10.5664V2.9375C1.3125 2.47266 1.69531 2.0625 2.1875 2.0625H10.9375Z",
    fill: "#F1F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIconWhite);
export default __webpack_public_path__ + "static/media/course_icon_white.c9e91a49f159193edc38115ca5c07bcc.svg";
export { ForwardRef as ReactComponent };